import { useState } from 'react';

/**
 * 廉航手續費計算器：機票原價 + 行李 + 刷卡手續費等 → 最終負擔
 */
export function LccFeeCalculatorTool() {
  const [ticketPrice, setTicketPrice] = useState('');
  const [baggage, setBaggage] = useState('');
  const [paymentFee, setPaymentFee] = useState('');
  const [other, setOther] = useState('');

  const ticket = Math.max(0, Number(ticketPrice) || 0);
  const bag = Math.max(0, Number(baggage) || 0);
  const pay = Math.max(0, Number(paymentFee) || 0);
  const rest = Math.max(0, Number(other) || 0);
  const total = ticket + bag + pay + rest;

  return (
    <>
      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-4 text-sm font-medium text-gray-700 dark:text-gray-300">
          輸入各項費用（新台幣）
        </h2>
        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
              機票原價
            </label>
            <input
              type="number"
              min="0"
              value={ticketPrice}
              onChange={e => setTicketPrice(e.target.value)}
              placeholder="例如 1999"
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
              行李費（託運/手提加購）
            </label>
            <input
              type="number"
              min="0"
              value={baggage}
              onChange={e => setBaggage(e.target.value)}
              placeholder="0"
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
              刷卡/金流手續費
            </label>
            <input
              type="number"
              min="0"
              value={paymentFee}
              onChange={e => setPaymentFee(e.target.value)}
              placeholder="0"
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-400">
              其他（選位、餐食等）
            </label>
            <input
              type="number"
              min="0"
              value={other}
              onChange={e => setOther(e.target.value)}
              placeholder="0"
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            />
          </div>
        </div>
      </div>

      <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
          最終負擔價格
        </h2>
        <p className="text-2xl font-bold text-primary">
          NT$ {total.toLocaleString()}
        </p>
        {ticket > 0 && total > ticket && (
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            比機票原價多 NT$ {(total - ticket).toLocaleString()}（隱藏成本）
          </p>
        )}
      </div>

      <section className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-lg font-semibold text-gray-900 dark:text-gray-100">
          使用說明
        </h2>
        <p className="leading-relaxed text-gray-600 dark:text-gray-400">
          廉航（LCC）常將行李、選位、刷卡手續費分開計價。輸入機票原價與各項加價後，可一次算出「真正要付的總額」，方便比價與預算控制。
        </p>
      </section>
    </>
  );
}
